import React, { useEffect, useState } from 'react';
import SiedBar from '../components/SiedBar';
import Header from '../components/Header';
import Experiences from '../pages/Expriences';
import Skills from '../pages/Skills';

import Interests from '../pages/Interests';
import Awards from '../pages/Awards';
import data from '../models/educationData.json';

import Educations from './Educations';
const Home = () => {
    const [experiences, setExperiences] = useState(data.expriences[0].fr);
    const [educations, setEducations] = useState(data.educations[0].fr);
    const [skills, setSkills] = useState(data.skills[0].fr);
    const [interests, setInterests] = useState(data.interests[0].fr);
    const [awards, setAwards] = useState(data.awards[0].fr);
    const [description, setDescription] = useState(data.header[0].fr[0].description);
    const [menu, setMenu] = useState(data.menu.fr);
    const [lng, setLngChange] = useState('Fr');
    const handleLngChange = (newLng) => {
        setLngChange(newLng);
    }
    useEffect(() => {
        if (lng === 'Fr') {
            setExperiences(data.expriences[0].fr);
            setEducations(data.educations[0].fr);
            setSkills(data.skills[0].fr);
            setInterests(data.interests[0].fr);
            setAwards(data.awards[0].fr);
            setDescription(data.header[0].fr[0].description);
            setMenu(data.menu.fr);


        } else {
            setExperiences(data.expriences[0].ang);
            setEducations(data.educations[0].ang);
            setSkills(data.skills[0].ang);
            setDescription(data.header[1].ang[0].description);
            setInterests(data.interests[0].ang);
            setAwards(data.awards[0].ang);
            setMenu(data.menu.ang);

        }

    }, [lng])


    return (
        <>

            <SiedBar data={menu} />
            <div className="container-fluid p-0">
                <Header handleLngChange={handleLngChange} descriptions={description} />
                <Experiences data={experiences} />
                <Educations data={educations} />
                <Skills data={skills} />
                <Interests data={interests} />
                <Awards data={awards} />
            </div>
        </>
    );
};

export default Home;